const Content01 = () => {
    return (
        <div className="col-span-5 w-full max-w-6xl mx-auto px-4 pt-10 text-[#FFFFFF] sm:pl-16 lg:col-span-3 lg:pt-20 xl:pl-44 2xl:pl-36">
            <div className="text-6xl font-semibold bg-gradient-to-b from-white to-[#5AE65E] bg-clip-text text-transparent">
                01.
            </div>
            <div className="mt-4 text-xl font-bold sm:text-2xl md:text-3xl">
                What's more about our chatbot?
            </div>

            <div className="flex items-center justify-start py-4">
                <div className="flex items-center">
                    <div className="h-[1px] w-20 bg-[#5AE65E]"></div>
                    <div
                        className="w-1 h-1 bg-[#5AE65E]"
                        style={{
                            clipPath:
                                'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)',
                        }}
                    ></div>
                </div>
            </div>

            <div className="mb-8 text-base font-normal text-[#BEBEBE]">
                Our chatbot stands out with a host of unique features
            </div>

            <div className="space-y-6 text-base text-white sm:pr-8 lg:text-sm xl:pr-20 xl:text-xs 2xl:text-sm">
                {[
                    {
                        title: 'Enable Response Targeting for Chatbots:',
                        desc: 'You can make settings so that the chatbot responds according to the wishes of the business.',
                    },
                    {
                        title: 'Configure Security and Access Control Settings:',
                        desc: "This allows you to set up access permissions for different accounts to access the chatbot's various databases.",
                    },
                    {
                        title: 'Comprehensive Chat History Storage and Management:',
                        desc: 'Every interaction with the chatbot is meticulously stored along with detailed information, including timestamps and customer info (if any).',
                    },
                    {
                        title: 'Not an ordinary chatbot but a powerful virtual assistant:',
                        desc: 'Zero Chat: unleashing a wave of benefits for businesses.',
                    },
                    {
                        title: 'Expanded Service Funnel:',
                        desc: 'Zero Chat can serve multiple customers across different fields simultaneously and in multiple languages. With its 24/7 availability, Zero Chat can access and assist customers at any time, reducing waiting times.',
                    },
                    {
                        title: 'Fast Deployment and Training:',
                        desc: "Zero Chat requires minimal time for AI training and setup. It's easy to integrate, expand, or scale down according to business needs.",
                    },
                    {
                        title: 'Cost Savings:',
                        desc: 'By automating customer support, Zero Chat significantly reduces costs associated with hiring and training support staff. Compared to maintaining a customer service team, using an automated tool like Zero Chat can result in substantial savings.',
                    },
                ].map((item, index) => (
                    <div key={index} className="flex items-start gap-2">
                        <img
                            src="/media/images/icon/checked.png"
                            alt="checked"
                            className="w-5 h-5"
                        />
                        <div>
                            <div className="font-medium">
                                <span className="font-bold">{item.title}</span>{' '}
                                {item.desc}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Content01
